import React from 'react';

import '@/components/Dashboard/components/styles/ratnaProgress.scss';

import ratnaImage from '@/images/discovery/newRatna.svg';

interface ProgressBarInterface {
  value: number;
  limit: number;
}

const RatnaProgress = ({ value, limit }: ProgressBarInterface) => {
  const percentage = (value / limit) * 100;

  return (
    <div className="flex flex-between items-center gap-4">
      <div className="ratna-progress-bar">
        <div className="relative">
          <div className="bar-container">
            <div
              className="bar"
              style={{
                width: `${percentage}%`,
              }}></div>
          </div>
          <img src={ratnaImage} alt="ratna" className="ratna-image" style={{ left: `${percentage - 4}%` }} />
        </div>
      </div>
      <div className="text-xs text-default flex-shrink-0 font-medium">
        <span>
          {value}/{limit}
        </span>
      </div>
    </div>
  );
};

export default RatnaProgress;
